import { render, staticRenderFns } from "./OptionToggleButton.vue?vue&type=template&id=8c564fc8&scoped=true&"
import script from "./OptionToggleButton.vue?vue&type=script&lang=js&"
export * from "./OptionToggleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c564fc8",
  null
  
)

export default component.exports